<div class="row">
    <div class="col-12 text-end">
        <button type="button" class="close" aria-label="Close" (click)="closeIcon()" style="font-size: 40px;color: red !important;">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>
<div #calendar class="mt-2"></div>